// extracted by mini-css-extract-plugin
export default {"dropdowns":"SearchBox__dropdowns___vmZr3","input":"SearchBox__input___Q1BdB","focused":"SearchBox__focused___miqqI"};